export const RESPONDENT = '[Respondent]';

export const CREATE_RESPONDENT_SAGA = `${RESPONDENT} CREATE_RESPONDENT_SAGA`;
export const SET_RESPONDENT_DATA = `${RESPONDENT} SET_RESPONDENT_DATA`;
export const GET_RESPONDENT_SAGA = `${RESPONDENT} GET_RESPONDENT_SAGA`;
export const OPEN_GENERATE_RESPONDENT_MODAL = `${RESPONDENT} OPEN_GENERATE_RESPONDENT_MODAL`;
export const OPEN_RESPONDENT_MODAL = `${RESPONDENT} OPEN_RESPONDENT_MODAL`;
